import { usePathname } from "next/navigation";
import { cn } from "@/src/utils/shadcn";
import { CustomLink } from "@/src/components/custom-link";
import { HeaderProps } from "../../v1";
import { FaChevronDown } from "react-icons/fa6";

const menuTriggerClasses = cn([
  "text-base leading-[1.3] capitalize py-4 min-h-[3.5rem] font-medium dark:text-white text-inherit dark:hover:text-primary hover:text-primary transition-colors duration-200",
  "inline-flex items-center justify-center gap-1.5",
  "focus:text-primary",
  "menu-link",
  "cursor-pointer",
]);

export function Navigation({ menuItems }: Pick<HeaderProps, "menuItems">) {
  const pathname = usePathname(); // Get the current path

  // Normalize path function
  const normalizePath = (path: string): string =>
    path.replace(/^\/(en|ar)\//, "/").replace(/\/$/, "");

  const activePath = normalizePath(pathname || "/"); // Normalize the current path

  return (
    <nav aria-label="primary navigation">
      <ul className="flex items-center gap-x-6">
        {menuItems.map((menuItem, index) => {
          const isActive = normalizePath(menuItem.href) === activePath;

          return (
            <li key={index} className="group/menu-item relative">
              {"title" in menuItem ? (
                <>
                  {/* Megamenu */}
                  <span
                    className={`${menuTriggerClasses} ${
                      isActive ? "text-primary" : ""
                    }`}
                  >
                    <span>{menuItem.title}</span>
                    <span className="text-[10px]">
                      <FaChevronDown />
                    </span>
                  </span>
                  {menuItem.subMenuItems && menuItem.subMenuItems.length > 0 && (
                    <nav aria-label="submenu-items" className="">
                      <ul className="grid divide-y divide-white/5">
                        {menuItem.subMenuItems.map((subMenuItem, index) => (
                          <li key={index} className="leading-none">
                            <CustomLink
                              href={subMenuItem.href}
                              openNewTab={subMenuItem.openNewTab}
                              className="flex min-h-[50px] items-center px-4 py-2 pr-6 text-[15px] font-normal capitalize text-white transition-colors duration-200 hover:bg-primary dark:text-white"
                            >
                              {subMenuItem.label}
                            </CustomLink>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  )}
                </>
              ) : (
                <>
                  {/* Normal link */}
                  <CustomLink
                    href={menuItem.href}
                    openNewTab={menuItem.openNewTab}
                    className={`leading-[1.3] capitalize py-4 min-h-[3.5rem] font-medium dark:text-white text-inherit dark:hover:text-primary hover:text-primary transition-colors duration-200 ${
                      isActive ? "text-primary" : ""
                    }`}
                  >
                    {menuItem.label}
                  </CustomLink>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
